__turbopack_context__.v({
  "graphContainer": "ChartWidgetContent-module__jJhqoq__graphContainer",
  "message": "ChartWidgetContent-module__jJhqoq__message",
  "skeleton": "ChartWidgetContent-module__jJhqoq__skeleton",
  "skeletonShimmer": "ChartWidgetContent-module__jJhqoq__skeletonShimmer",
});
